<template>
    <div class="content">
        <p>Let's go. Get a link to download the app</p>
        <form action=" https://getform.io/f/626e1ed4-fd0a-483e-a4a4-9b22dd191542" method="POST">
            <input type="email" required placeholder="Enter email address" name="email">
            <input type="submit" value="Apply to drive">
        </form>
    </div>
</template>
<script>
    export default {
        name: 'apply'
    }
</script>
<style scoped>
    .content{
        position: relative;
        background-color: #011A51;
        border-radius: 8px;
        width: 100%;
        padding: 10px;
        text-align: center;
        font-family: 'Helvetica', sans-serif;
    }
     .content p{
        color: #fff;
        margin-bottom: 10px;
    }
     .content form{
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        width: 100%;
        gap: 10px;
        display: flex;
    }
     .content input{
        border: none;
        outline: none;
        padding: 11px;
        border-radius: 8px;
        font-size: 11px;
        width: 100%;
        font-family: 'Helvetica', sans-serif;
    }
      .content input[type="submit"]{
        background-color: #f60;
        color: #fff;
         text-transform: uppercase;
        width: 120px;
        font-family: 'Helvetica', sans-serif;
    }
     .content input[type="email"]{
        width: 260px;
        background-color: #fff;
        font-family: 'Helvetica', sans-serif;
    }
     .content input[type="email"]::placeholder{
        color: #dadada;
    }
    @media screen and (min-width:768px) {
         .content{
            padding: 1.4rem;
        }
         .content input{
            padding: 12.5px;
            font-size: 12px;
        }
         .content p{
            font-size: 17px;
            margin-bottom: 1rem;
        }
    }
    @media screen and (min-width: 1010px) {

         
         .content{
            padding: 2rem;
            display: flex;
            justify-content: space-between;
            gap: 3rem;
        }
         .content p{
            margin-bottom: 0;
            font-size: 20px;
            flex: 1;
            font-family: 'Helvetica', sans-serif;
        }
         .content form{
            flex: 3;
        }
        .content input{
            font-size: 22px;
            padding: 14.5px;
        }
         .content input[type="email"]{
        width: 399px;
        }
         .content input[type="submit"]{
            width: 220px;
        }
    }
    @media screen and (min-width: 1280px) {
        .content p{
            font-size: 24.6px;
        }
        .content input[type="email"]{
            width: 499px;
        }
         .content input[type="submit"]{
            width: 260px;
        }
    }
    
    </style>